import { usePumpSizing } from "../../context/PumpSizingContext";
import { TdhModeSelector } from "../shared/TdhModeSelector";
import { TdhSumpHelp } from "./tdh/TdhSumpHelp";
import { TdhStandardHelp } from "./tdh/TdhStandardHelp";

function TdhHelpForm() {
	const { formData } = usePumpSizing();

	switch (formData.applicationType) {
		case "sump":
			return <TdhSumpHelp />;
		case "septic":
		case "sewage":
			return <TdhStandardHelp />;
		default:
			return null;
	}
}

export function StepTdh() {
	const { formData, setTdhMode, setKnownTdh } = usePumpSizing();
	const { tdhData } = formData;

	return (
		<div className="pf-step pf-step--tdh">
			<TdhModeSelector
				mode={tdhData.mode}
				knownTdh={tdhData.knownTdh}
				onModeChange={setTdhMode}
				onKnownTdhChange={setKnownTdh}
			/>

			{tdhData.mode === "help" ? <TdhHelpForm /> : null}
		</div>
	);
}
